import { GET_APP_MODE }    from '@appConfig/_app-config_master';
import { APP_MODE }        from '@appConfig/app-mode-config';
import { environment }     from '@env/environment';
import { EnvironmentEnum } from '@env/environment.model';
// import { MatomoConsentMode }          from '@ngx-matomo/tracker';
// import { MatomoTrackerConfiguration } from '@ngx-matomo/tracker/lib/configuration';

/**
 * Our general configuration for the analytics.
 */
export interface IAnalyticsDataConfig {
	readonly featureEnabled: boolean;
	readonly userAgentData: string;
	// readonly consentMode: MatomoConsentMode;
}

/**
 * Enable the analytics feature for the given environments.
 */
export const ENABLED_ENVIRONMENTS: EnvironmentEnum[] = [
	EnvironmentEnum.STABLE,
	EnvironmentEnum.STAGING,
	EnvironmentEnum.UNSTABLE
];

/**
 * Matomo tracking URL for each environment.
 */
export const TRACKER_URL_ENVIRONMENTS = {
	[ EnvironmentEnum.UNSTABLE ]: 'https://matomo-unstable.tools.fiskal.cloud/',
	[ EnvironmentEnum.STAGING ]: 'https://matomo-staging.tools.fiskal.cloud/', // staging is impossible to detect right now
	[ EnvironmentEnum.STABLE ]: 'https://matomo-stable.tools.fiskal.cloud/'
};

export const MATOMO_TRACKER_URL_BY_ENVIRONMENT: string = TRACKER_URL_ENVIRONMENTS[ environment.activeEnvironment ];

/**
 * Our analytics configuration (with parts of Matomo for module instantiation).
 */
export const ANALYTICS_CONFIG: IAnalyticsDataConfig = {
	featureEnabled: GET_APP_MODE() !== APP_MODE.LOCAL && ENABLED_ENVIRONMENTS.includes( environment.activeEnvironment ),	// enabled by environment
	userAgentData: 'userAgentData'  																								// used for data gaining from browser
	// consentMode: MatomoConsentMode.TRACKING																					// consent mode (Matomo)
};

/**
 * Pure Matomo config.
 */
// export const MATOMO_TRACKER_CONFIG: MatomoTrackerConfiguration = {
// 	siteId: '1', 													// your Matomo's site ID (find it in your Matomo's settings)
// 	trackerUrl: trackerUrlByEnvironment,	// your matomo server root url
// };
